// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OrganizationIntegrationsQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type OrganizationIntegrationsQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationDetails?: {
    __typename?: "Organization";
    id: string;
    permittedToEditOrganization: boolean;
    planInfo: {
      __typename?: "OrganizationPlanInfo";
      id: string;
      isTrial: boolean;
    };
    defaultSamlRole?: {
      __typename?: "OrganizationRole";
      id: string;
      name: string;
    } | null;
    slackIntegration?: {
      __typename?: "SlackIntegration";
      id: string;
      createdAt: number;
      authInvalid: boolean;
      integratedBy: {
        __typename?: "User";
        id: string;
        fullname?: string | null;
        avatarUrl?: string | null;
      };
      availableChannels: {
        __typename?: "SlackChannelList";
        error?: string | null;
        channels: Array<{
          __typename?: "SlackChannel";
          id: string;
          name: string;
        }>;
      };
    } | null;
    pagerdutyIntegration?: {
      __typename?: "PagerdutyIntegration";
      id: string;
      createdAt: number;
      authInvalid: boolean;
      integratedBy: {
        __typename?: "User";
        id: string;
        fullname?: string | null;
        avatarUrl?: string | null;
      };
      availableServices: Array<{
        __typename?: "PagerdutyService";
        id: string;
        name: string;
      }>;
    } | null;
    samlIntegration?: {
      __typename?: "SamlIntegration";
      id: string;
      createdAt: number;
      authInvalid: boolean;
      idpEntityId: string;
      idpCertExpiresAt?: number | null;
      integratedBy: {
        __typename?: "User";
        id: string;
        fullname?: string | null;
        avatarUrl?: string | null;
      };
    } | null;
  } | null;
  getOrganizationRoles: Array<{
    __typename?: "OrganizationRole";
    id: string;
    name: string;
  }>;
};

export const OrganizationIntegrationsDocument = gql`
  query OrganizationIntegrations($organizationSlug: ID!) {
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      id
      permittedToEditOrganization
      planInfo {
        id
        isTrial
      }
      defaultSamlRole {
        id
        name
      }
      slackIntegration {
        id
        createdAt
        authInvalid
        integratedBy {
          id
          fullname
          avatarUrl
        }
        availableChannels {
          error
          channels {
            id
            name
          }
        }
      }
      pagerdutyIntegration {
        id
        createdAt
        authInvalid
        integratedBy {
          id
          fullname
          avatarUrl
        }
        availableServices {
          id
          name
        }
      }
      samlIntegration {
        id
        createdAt
        authInvalid
        idpEntityId
        idpCertExpiresAt
        integratedBy {
          id
          fullname
          avatarUrl
        }
      }
    }
    getOrganizationRoles(organizationSlug: $organizationSlug) {
      id
      name
    }
  }
`;

/**
 * __useOrganizationIntegrationsQuery__
 *
 * To run a query within a React component, call `useOrganizationIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationIntegrationsQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useOrganizationIntegrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrganizationIntegrationsQuery,
    OrganizationIntegrationsQueryVariables
  > &
    (
      | { variables: OrganizationIntegrationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationIntegrationsQuery,
    OrganizationIntegrationsQueryVariables
  >(OrganizationIntegrationsDocument, options);
}
export function useOrganizationIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationIntegrationsQuery,
    OrganizationIntegrationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationIntegrationsQuery,
    OrganizationIntegrationsQueryVariables
  >(OrganizationIntegrationsDocument, options);
}
// @ts-ignore
export function useOrganizationIntegrationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrganizationIntegrationsQuery,
    OrganizationIntegrationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OrganizationIntegrationsQuery,
  OrganizationIntegrationsQueryVariables
>;
export function useOrganizationIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationIntegrationsQuery,
        OrganizationIntegrationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OrganizationIntegrationsQuery | undefined,
  OrganizationIntegrationsQueryVariables
>;
export function useOrganizationIntegrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationIntegrationsQuery,
        OrganizationIntegrationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OrganizationIntegrationsQuery,
    OrganizationIntegrationsQueryVariables
  >(OrganizationIntegrationsDocument, options);
}
export type OrganizationIntegrationsQueryHookResult = ReturnType<
  typeof useOrganizationIntegrationsQuery
>;
export type OrganizationIntegrationsLazyQueryHookResult = ReturnType<
  typeof useOrganizationIntegrationsLazyQuery
>;
export type OrganizationIntegrationsSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationIntegrationsSuspenseQuery
>;
export type OrganizationIntegrationsQueryResult = Apollo.QueryResult<
  OrganizationIntegrationsQuery,
  OrganizationIntegrationsQueryVariables
>;
